var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.5,
    height: 73.5,
    viewBox: "0 0 73.5 73.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M66.851,0H6.649A6.649,6.649,0,0,0,0,6.649v60.2A6.649,6.649,0,0,0,6.649,73.5h60.2A6.649,6.649,0,0,0,73.5,66.851V6.649A6.649,6.649,0,0,0,66.851,0ZM22.744,63.465A1.935,1.935,0,0,1,20.809,65.4H12.573a1.935,1.935,0,0,1-1.935-1.935V28.939A1.935,1.935,0,0,1,12.573,27h8.236a1.935,1.935,0,0,1,1.935,1.935ZM16.691,23.749a7.824,7.824,0,1,1,7.824-7.824A7.825,7.825,0,0,1,16.691,23.749Zm49.1,39.871A1.779,1.779,0,0,1,64.007,65.4H55.169a1.779,1.779,0,0,1-1.779-1.779V47.426c0-2.416.709-10.586-6.313-10.586-5.447,0-6.552,5.593-6.774,8.1V63.621A1.779,1.779,0,0,1,38.524,65.4H29.976A1.779,1.779,0,0,1,28.2,63.621V28.783A1.779,1.779,0,0,1,29.976,27h8.548A1.779,1.779,0,0,1,40.3,28.783V31.8c2.02-3.031,5.021-5.371,11.412-5.371,14.152,0,14.071,13.222,14.071,20.486v16.71Z",
    fill: "#51aabc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconLinkedin);
export default __webpack_public_path__ + "static/media/menu_icon_linkedin.e688d916.svg";
export { ForwardRef as ReactComponent };